import { useEffect, useState } from "react";
import PayoneerApi from "../../api/payoneerApi";
import PayoutApi from "../../api/payoutApi";
import MultipleSelect from "../../components/MultipleSelect/MultipleSelect";
import {
  BankPayRequest,
  PayoneerPayRequest,
  PayRequestsStatuses,
} from "../../types/PayoutTypes";
import Bank from "./Bank/Bank";
import Payoneer from "./Payoneer/Payoneer";
import s from "./Withdrawals.module.css";

type TabValueType = "payoneer" | "bank";

type BankRequestFilters = {
  status?: PayRequestsStatuses;
};
type PayoneerRequestFilters = {
  status?: PayRequestsStatuses;
};
const Withdrawals = () => {
  const token = localStorage.getItem("token");
  const [activeTab, setActiveTab] = useState<TabValueType>("payoneer");
  const [paggination, setPaggination] = useState({
    payoneer: {
      page: 0,
      limit: 10,
      total: 0,
    },
    bank: {
      page: 0,
      limit: 10,
      total: 0,
    },
  });
  const [requests, setRequests] = useState<{
    bankRequests: BankPayRequest[];
    payoneerRequests: PayoneerPayRequest[];
  }>({ bankRequests: [], payoneerRequests: [] });
  const [filters, setFilters] = useState<{
    payoneerFilters: PayoneerRequestFilters;
    bankFilters: BankRequestFilters;
  }>({
    payoneerFilters: {},
    bankFilters: {},
  });

  const getPayoneerRequests = async () => {
    if (!token) return;
    const response = await PayoneerApi.getPayoneerPayRequests(
      token,
      paggination.payoneer.page + 1,
      paggination.payoneer.limit,
      filters.payoneerFilters.status,
    );

    if (response.status && response.requests) {
      setRequests((prev) => ({
        ...prev,
        payoneerRequests: response.requests!,
      }));
      setPaggination((prev) => ({
        ...prev,
        payoneer: { ...prev.payoneer, total: response.totalAmount },
      }));
    }
  };

  const getBankRequests = async () => {
    if (!token) return;
    const response = await PayoutApi.getBankPayRequests(
      token,
      paggination.bank.page + 1,
      paggination.bank.limit,
      filters.bankFilters.status,
    );

    if (response.status && response.requests) {
      setRequests((prev) => ({
        ...prev,
        bankRequests: response.requests!,
      }));
      setPaggination((prev) => ({
        ...prev,
        bank: { ...prev.bank, total: response.totalAmount },
      }));
    }
  };

  useEffect(() => {
    getPayoneerRequests();
  }, [
    paggination.payoneer.page,
    paggination.payoneer.limit,
    filters.payoneerFilters,
  ]);

  useEffect(() => {
    getBankRequests();
  }, [paggination.bank.page, paggination.bank.limit, filters.bankFilters]);

  const payRequestStatusOptions: { value: string; lable: string }[] =
    Object.values(PayRequestsStatuses).map((status) => ({
      value: status,
      lable: status.charAt(0).toUpperCase() + status.slice(1),
    }));

  const allTabs: {
    value: TabValueType;
    label: string;
    component: JSX.Element;
  }[] = [
    {
      label: "Payoneer",
      value: "payoneer",
      component: (
        <Payoneer
          count={paggination.payoneer.total}
          page={paggination.payoneer.page}
          requestData={requests.payoneerRequests}
          rowsPerPage={paggination.payoneer.limit}
          setPage={(value: number) =>
            setPaggination((prev) => ({
              ...prev,
              payoneer: { ...prev.payoneer, page: value },
            }))
          }
          setRowsPerPage={(value: number) =>
            setPaggination((prev) => ({
              ...prev,
              payoneer: { ...prev.payoneer, limit: value },
            }))
          }
          setRequests={setRequests}
        />
      ),
    },
    {
      label: "Bank",
      value: "bank",
      component: (
        <Bank
          count={paggination.bank.total}
          page={paggination.bank.page}
          requestData={requests.bankRequests}
          rowsPerPage={paggination.bank.limit}
          setPage={(value: number) =>
            setPaggination((prev) => ({
              ...prev,
              bank: { ...prev.bank, page: value },
            }))
          }
          setRowsPerPage={(value: number) =>
            setPaggination((prev) => ({
              ...prev,
              bank: { ...prev.bank, limit: value },
            }))
          }
          setRequests={setRequests}
        />
      ),
    },
  ];

  return (
    <div className={s.container}>
      <div className={s.tabsBlock}>
        {allTabs.map((item, index) => (
          <div
            className={activeTab === item.value ? s.activeTab : s.notActiveTab}
            onClick={() => {
              setActiveTab(item.value);
            }}
            key={index}
          >
            <span>{item.label}</span>
            <span
              className={
                activeTab === item.value
                  ? s.tabActiveIndicator
                  : s.indicatorHidden
              }
            ></span>
          </div>
        ))}
      </div>
      <div className={s.filtersBlock}>
        <MultipleSelect
          data={[...payRequestStatusOptions, { value: "All", lable: "All" }]}
          value={
            (activeTab === "bank"
              ? filters.bankFilters.status
              : filters.payoneerFilters.status) ?? "All"
          }
          multiplie={false}
          setValue={(value) => {
            setPaggination((prev) => {
              if (activeTab === "bank") {
                return {
                  ...prev,
                  bank: {
                    ...prev.bank,
                    page: 0,
                  },
                };
              }
              if (activeTab === "payoneer") {
                return {
                  ...prev,
                  payoneer: {
                    ...prev.payoneer,
                    page: 0,
                  },
                };
              }
              return prev;
            });
            const newValue = value === "All" ? undefined : value;
            setFilters((prev) => {
              if (activeTab === "bank") {
                return {
                  ...prev,
                  bankFilters: {
                    ...prev.bankFilters,
                    status: newValue as PayRequestsStatuses | undefined,
                  },
                };
              }
              if (activeTab === "payoneer") {
                return {
                  ...prev,
                  payoneerFilters: {
                    ...prev.payoneerFilters,
                    status: newValue as PayRequestsStatuses | undefined,
                  },
                };
              }
              return prev;
            });
          }}
          lable="Requests status"
          width="150px"
          disableSortData
        />
      </div>
      <div className={s.contentBlock}>
        {allTabs.find((el) => el.value === activeTab)?.component}
      </div>
    </div>
  );
};

export default Withdrawals;
